module.exports = __webpack_public_path__ + "img/0.d285b402.jpg";